import { Injectable } from '@angular/core';
import { ApiHttpService } from 'src/app/core/services/api-http.service';
import { ApiEndpointsService } from 'src/app/core/services/api-endpoints.service';
import { QueryStringParameters } from 'src/app/shared/classes/query-string-parameters';

@Injectable({ providedIn: 'root' })
export class StationService {
  constructor(private apiHttpService: ApiHttpService, private apiEndpointsService: ApiEndpointsService) {}
  public createStation(body: any) {
    const url: string = this.apiEndpointsService.createUrl('station');
    return this.apiHttpService.post(url, body);
  }
  public getAllStation(slug: string) {
    const url: string = this.apiEndpointsService.createUrlWithQueryParameters('station', (qs: QueryStringParameters) => qs.push('restaurant_id', slug));
    return this.apiHttpService.get(url);
  }
  public updateStationById(id: string, body: object) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('station', [id]);
    return this.apiHttpService.put(url, body);
  }
  public updateStationObjectById(id: string, body: object) {
    const payload: any = body;
    delete payload._id;
    const url: string = this.apiEndpointsService.createUrlWithPathVariables(`station-object/${id}`);
    return this.apiHttpService.put(url, payload);
  }
  public deleteStationById(id: string) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('station', [id]);
    return this.apiHttpService.delete(url);
  }
}
